import React, { FC } from 'react';
import { Link } from 'gatsby';
import { isBrowser } from '../../utils';

interface LinkToProps {
  to: string;
  onClick?: any;
  className?: string;
  state?: any;
  id?: string;
  label?: string;
  title?: string;
  target?: string;
}

export const LinkTo: FC<React.PropsWithChildren<LinkToProps>> = ({
  to,
  children,
  label,
  onClick,
  state,
  title,
  target,
  id,
  ...rest
}) => {
  const domain = process.env.GATSBY_FRONTEND_URL;
  let link = to;
  let isExternal = to?.trim().startsWith('http') || target === '_blank';
  const isAnchor = to?.trim().startsWith('#');
  const isMail = to?.trim().startsWith('mailto');
  const isTel = to?.trim().startsWith('tel');

  // Internalize links matching your domain
  if (to && isExternal && domain && link?.includes(domain)) {
    [, link] = to.split(domain);
    isExternal = false;
  }

  // Append tracking params if the link matches the quote URL
  if (
    isBrowser &&
    link === 'https://quotes.tradedirectinsurance.co.uk/frm_1_PL_BasicInfo.aspx'
  ) {
    const currentParams = new URLSearchParams(window.location.search);
    const paramKeys = [
      'utm_source',
      'utm_medium',
      'utm_content',
      'utm_campaign',
      'gclid',
    ];

    const trackingParams = new URLSearchParams();

    paramKeys.forEach((key) => {
      const value = currentParams.get(key);
      if (value) trackingParams.set(key, value);
    });

    if ([...trackingParams].length) {
      const separator = link.includes('?') ? '&' : '?';
      link += separator + trackingParams.toString();
    }
  }

  return isExternal || isAnchor || isMail || isTel ? (
    <a
      href={link}
      target={isExternal ? '_blank' : ''}
      rel={isExternal ? 'noopener' : ''}
      onClick={onClick}
      id={id}
      title={title}
      {...rest}
    >
      {label || children}
    </a>
  ) : (
    <Link
      to={link}
      id={id}
      activeClassName="is-active"
      onClick={onClick}
      title={title}
      state={state}
      {...rest}
    >
      {label || children}
    </Link>
  );
};

export default LinkTo;
